if ($('.js-magnify').length) {
	$('.js-magnify').magnify();
}
